export default __webpack_public_path__ + "static/media/search.cc28d6db.svg";